import {CamToCamBase} from "./cam2cam-base";
import {Status} from "./cam2cam";
import {WebRtcPublisherNg} from "../publisher/webrtc-publisher-ng";
import logging from "../utils/log";
import {AppState} from "../application/application";

export class CamToCamWebRTCNg extends CamToCamBase {
    protected TAG = "[Sxc.Chat.CamToCamWebRTCNg]";
    protected publisher : WebRtcPublisherNg;
    protected handler = this.publishStream.bind(this);

    show(): Promise<any> {
        if (this.status !== Status.idle) {
            return Promise.reject(null);
        }

        this.publisher = new WebRtcPublisherNg(this.$root.find(".sxccc-publisher"));

        return this.publisher.init(this.app)
            .then(() => {
                return new Promise((resolve, reject) => {
                    this.setStatus(Status.approve);

                    this.$root.find('.sxccc-publisher.sxcccp-webrtc')
                        .addClass('sxc-visible');

                    // cancel if user does not act (approve/deny media access) in 15 seconds
                    let cancel = setTimeout(this.leave.bind(this), 15000);

                    this.publisher.askForCam(this.cam, this.mic)
                        .then(() => {
                            this.setStatus(Status.camApproved);
                            this.prepareSettings();
                            resolve();
                            this.publish();
                        })
                        .catch(err => {
                            logging.error(this.TAG, 'publisher.askForCam failed', err);
                            this.leave().then(() => {
                                reject(err);
                            });
                        })
                        .finally(() => {
                            clearTimeout(cancel);
                        });
                });
            })
            .catch(err => {
                if (err instanceof Error) {
                    err = err.message;
                }

                logging.error(this.TAG, 'publisher.init failed', err);

                this.leave().finally(() => {
                  return Promise.reject(err);
                });
            });
    }

    publish() {
        this.setStatus(Status.prepareStream);
        this.publisher.showPreview(true);

        this.handler(this.app.getState());
    }

    public leave(): Promise<any> {
        this.app.event.off('setState', this.handler);

        return super.leave();
    }

    private publishStream(appState? : AppState) {
        logging.log(this.TAG, 'publishStream', appState);

        if (appState === (appState & (AppState.groupShow | AppState.privateShow | AppState.exclusiveShow))) {
            //this.publisher.publish('dummy', this.cam, this.mic)
            this.publisher.publish('dummy')
                .then(() => {
                    this.setStatus(Status.streaming);

                    this.app.chatServer.startCamToCam("webrtc").then(() => {
                        this.snapshots.init(this.publisher);
                    }).catch((reason) => {
                        logging.log(this.TAG, 'publish.startCam2Cam failed', reason);

                        return this.leave();
                    });
                });
        } else {
            this.app.event.one('setState', this.handler);
        }
    }
}